import { Autocomplete, Button, Grid, InputLabel, TextField, Typography } from '@mui/material'
import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react'
import styles from '../../../assets/styles/componentStyles/dataconnectorform.module.scss'
import globalStyles from "../../../assets/styles/global.module.scss";
import GlobalTextField from '../../utility/globalTextfield';
import Required from '../../utility/required';
import connectorstyle from '../../../assets/styles/componentStyles/dataconnector.module.scss'
import contactStyles from "../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import validator from 'validator';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { chronoxUserRolesDataModel, organizationRoleInterface } from '../../../models/axiosModel';
import { ADMIN_ASSIGNABLE_ROLES, CHRONOX_USER_ROLE_ID_KEY, DEVELOPER_ASSIGNABLE_ROLES, ORGANIZATION_ROLE_ID_KEY, OWNER_ASSIGNABLE_ROLES, PRIVATE_USER_EMAIL_KEY, PRIVATE_USER_FIRST_NAME_KEY, PRIVATE_USER_LAST_NAME_KEY } from './organizationConstants';
import { getEffectiveAdminRoleName, getEffectiveUserRoleName, ORGANIZATION_ROLES, USER_ASSIGNMENT_ROLES } from '../../../utils/constants';

export interface addMemberPayload {
    private_user_email: string,
    private_user_first_name: string,
    private_user_last_name: string,
    organization_role_id: number | null,
    private_user_id: number | null,
    chronox_user_role_id: string | null,
}
interface AddMemberProps {
    flagKeyExistError: boolean;
    setFlagKeyExistError: Dispatch<SetStateAction<boolean>>;
    addMemberPayload: addMemberPayload
    onChangePayload: (value: string | number | null, keyName: string) => void,
    handleShareInvitation: () => void,
    cancel: () => void,
    flagEditMember: boolean,
}
const AddMember = (props: AddMemberProps) => {

    const { setFlagLoading, organizationRole, getOrganizationRoleApi, handleError, userDetail, chronoxUserRolesData, getChronoxUserRoleApi } = useContext(UserContext) as UserContextPayload;

    const getSaveBtnDisableVal = () => {
        if ((props.addMemberPayload.private_user_email && props.addMemberPayload.private_user_email?.trim() !== "") && (props.addMemberPayload.private_user_first_name && props.addMemberPayload.private_user_first_name?.trim() !== "") && (props.addMemberPayload.private_user_last_name && props.addMemberPayload.private_user_last_name?.trim() !== "") && props.addMemberPayload.organization_role_id) {
            return false
        } else {
            return true
        }
    }

    const getOrganizationRoleApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getOrganizationRoleApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getChronoxUserRoleApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await getChronoxUserRoleApi();
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if (!organizationRole) {
            getOrganizationRoleApiCall();
        }

        if (!chronoxUserRolesData) {
            getChronoxUserRoleApiCall();
        }
    }, [])

    const getValueOfOrganizationRole = () => {
        const role = organizationRole?.find((role) => role?.role_id == props?.addMemberPayload?.organization_role_id);
        if (role) {
            return role;
        }
        return null;
    }

    const getValueOfNewOrganizationRole = () => {
        const role = chronoxUserRolesData?.find((role) => role?.chronox_user_role_id == props?.addMemberPayload?.chronox_user_role_id);
        if (role) return role;
        return null;
    }

    const hasPermissionToAssignRole = (option: organizationRoleInterface) => {
        const targetRoleName = option?.role_name?.toLowerCase();
        const ownerRole = ORGANIZATION_ROLES["OWNER_ROLE"]?.toLowerCase();

        const userRole = getEffectiveUserRoleName(userDetail);
        const adminRole = getEffectiveAdminRoleName(userDetail);

        if (userRole === adminRole) {
            return targetRoleName !== ownerRole;
        }

        return true;
    }

    const hasPermissionToAssignNewRole = (option: chronoxUserRolesDataModel) => {
        const targetRoleName = option?.chronox_user_role_name?.toLowerCase();

        const userRole = getEffectiveUserRoleName(userDetail);
        const adminRoleName = getEffectiveAdminRoleName(userDetail);

        switch (userRole) {
            case USER_ASSIGNMENT_ROLES["SUPER_OWNER_ROLE"]?.toLowerCase():
                return true;
            case adminRoleName:
                return ADMIN_ASSIGNABLE_ROLES.includes(targetRoleName);
            case USER_ASSIGNMENT_ROLES["OWNER_ROLE"]?.toLowerCase():
                return OWNER_ASSIGNABLE_ROLES.includes(targetRoleName);
            case USER_ASSIGNMENT_ROLES["DEVELOPER_ROLE"]?.toLowerCase():
                return DEVELOPER_ASSIGNABLE_ROLES.includes(targetRoleName);
            default:
                return true;
        }
    }

    const renderTextField = (value: string, key: string, placeholder: string, isDisabled: boolean) => {
        return (
            <TextField
                value={value}
                onChange={(event) => {
                    if (key == PRIVATE_USER_EMAIL_KEY) {
                        props.setFlagKeyExistError(false);
                    }
                    props.onChangePayload(event.target.value, key);
                }}
                placeholder={placeholder}
                className={`${contactStyles.campaignContactPopupTextField} ${globalStyles.fullwidth}`}
                disabled={isDisabled}
            />
        );
    }

    const getNewMemberRoleOptions = () => {
        if(chronoxUserRolesData){
            const hidenUserRoles = [USER_ASSIGNMENT_ROLES["DEVELOPER_ROLE"]?.toLowerCase(), USER_ASSIGNMENT_ROLES["SUPER_OWNER_ROLE"]?.toLowerCase()];
            return chronoxUserRolesData?.filter((role) => !hidenUserRoles?.includes(role?.chronox_user_role_name?.toLowerCase()))
        } 
        return [];
    }

    return (
        <>
            <Grid container className={`${styles.dataConnectorPopupSpacing}`}>
                <Grid item xs={12} className={`${styles.dataConnectorFormPopup} ${styles.dataConnectorPopupBorderItem}`}>
                    <Grid container>
                        <Grid item xs={12} style={{ textAlign: "center" }}>
                            <Typography
                                component='span'
                                className={styles.dataConnectorHeaderText}
                            >
                                {props.flagEditMember ? "Edit Member Details" : "Add New Member"}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <hr className={styles.dataconnectorHeaderDivider} />
                        </Grid>
                        <Grid item xs={12} pt={1}>
                            <Grid container>
                                <Grid item xs={12}>
                                    <Grid container direction={"column"} className={connectorstyle.createFormField} gap={"20px"} p={1}>
                                        <Grid item>
                                            <Grid container direction={{ xs: "column", sm: "row" }} gap={2} flexWrap={"nowrap"}>
                                                <Grid item xs={12} sm={6}>
                                                    <Grid container direction={"column"}>
                                                        <Grid item mb={1}>
                                                            <Typography className={contactStyles.popupFieldTypography}>
                                                                First Name <Required />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            {renderTextField(props.addMemberPayload.private_user_first_name, PRIVATE_USER_FIRST_NAME_KEY, "Enter First Name", false)}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} sm={6}>
                                                    <Grid container direction={"column"}>
                                                        <Grid item mb={1}>
                                                            <Typography className={contactStyles.popupFieldTypography}>
                                                                Last Name <Required />
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item>
                                                            {renderTextField(props.addMemberPayload.private_user_last_name, PRIVATE_USER_LAST_NAME_KEY, "Enter Last Name", false)}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item>
                                            <Grid container direction={"column"}>
                                                <Grid item mb={1}>
                                                    <Typography className={contactStyles.popupFieldTypography}>
                                                        Email Address <Required />
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    {renderTextField(props.addMemberPayload.private_user_email, PRIVATE_USER_EMAIL_KEY, "Enter Email Address", props.flagEditMember)}
                                                </Grid>
                                                {props.flagKeyExistError &&
                                                    !validator.isEmail(props.addMemberPayload.private_user_email.trim()) &&
                                                    <span className={globalStyles.validationText}>Please Enter a valid Email Address.</span>
                                                }
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid container direction={"column"}>
                                                <Grid item mb={1}>
                                                    <Typography className={contactStyles.popupFieldTypography}>
                                                        Member Role <Required />
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Autocomplete
                                                        className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                        options={organizationRole ?? []}
                                                        getOptionLabel={(option) => option.role_name || ''}
                                                        value={getValueOfOrganizationRole()}
                                                        getOptionDisabled={(option) => !hasPermissionToAssignRole(option)}
                                                        onChange={(_, value: organizationRoleInterface | null) => props.onChangePayload(value ? value?.role_id : null, ORGANIZATION_ROLE_ID_KEY)}
                                                        renderInput={(params) => <TextField {...params} placeholder="Select Member Role" />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid item>
                                            <Grid container direction={"column"}>
                                                <Grid item mb={1}>
                                                    <Typography className={contactStyles.popupFieldTypography}>
                                                        New Member Role
                                                    </Typography>
                                                </Grid>
                                                <Grid item>
                                                    <Autocomplete
                                                        className={`${contactStyles.contactFilterDropdownsInPopup}`}
                                                        options={getNewMemberRoleOptions()}
                                                        getOptionLabel={(option) => option.chronox_user_role_name || ''}
                                                        value={getValueOfNewOrganizationRole()}
                                                        getOptionDisabled={(option) => !hasPermissionToAssignNewRole(option)}
                                                        onChange={(_, value: chronoxUserRolesDataModel | null) => props.onChangePayload(value ? value?.chronox_user_role_id : null, CHRONOX_USER_ROLE_ID_KEY)}
                                                        renderInput={(params) => <TextField {...params} placeholder="Select New Member Role" />}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} mt={3}>
                            <Grid container className={`${globalStyles.globalHeadMainItemRightContainer} ${globalStyles.alignItemCenter}`}>

                                <Grid item xs={12} className={`${connectorstyle.globalHeadRightSubItem} `}>
                                    <Grid container className={`${globalStyles.alignItemCenter} ${globalStyles.justifyCenter}`} flexWrap={"nowrap"} gap={"15px"}>
                                        <Grid item>
                                            <Button
                                                variant="outlined"
                                                size="medium"
                                                fullWidth
                                                className={connectorstyle.cbCancelButton}
                                                onClick={() => { props.cancel() }}
                                            >
                                                Cancel
                                            </Button>
                                        </Grid>
                                        <Grid item>
                                            <Button
                                                variant="contained"
                                                size="medium"
                                                fullWidth
                                                disabled={getSaveBtnDisableVal()}
                                                className={`${connectorstyle.cbSaveButton} ${getSaveBtnDisableVal() ? styles.saveAddMemberBtnLowOpacity : ""}`}
                                                onClick={() => { props.handleShareInvitation() }}
                                            >
                                                {props.flagEditMember ? "Save" : "Add"}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AddMember
